const baseUrl = process.env.NODE_ENV === 'production'
  ? process.env.PUBLIC_URL
  : '';

export default baseUrl;
